import { organisationConstants } from '../../_constants/organisation.constants';

const initialState = { enable_pi_loading : true, enable_pi: '', enable_pi_error: false};

export function enablePi(state = initialState, action) {
    switch (action.type) {
      case organisationConstants.REQUEST_ENABLE_PI:
        return {
            enable_pi_loading: true,
            enable_pi: '',
            enable_pi_error: false
        };
      case organisationConstants.RESPONSE_ENABLE_PI:
        return {
            enable_pi_loading: false,
            enable_pi: action.enable_pi,
            enable_pi_error: false
        };
      case organisationConstants.ERROR_ENABLE_PI:
        return { 
            enable_pi_loading: false,
            enable_pi: '',
            enable_pi_error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/enablePi.reducer.js